module.exports = __webpack_public_path__ + "img/SEBP-PM.2c7b9789.svg";